module.exports = __webpack_public_path__ + "img/squarelogo.09014c0b.png";